import { Fragment } from 'preact';
import { GOLD } from '../../lib/medievalTheme';
import PlayerChip from './PlayerChip';
import { t } from '../../localization/t';

function VsDivider() {
  return (
    <div className="shrink-0 flex flex-col items-center justify-center px-2" aria-hidden="true">
      <span
        className="text-[0.6875cqw] font-bold"
        style={{
          color: `${GOLD} 0.85)`,
          textShadow: `0 0 8px ${GOLD} 0.4)`,
        }}
      >
        {t('vs')}
      </span>
    </div>
  );
}

function DotDivider() {
  return (
    <span
      aria-hidden="true"
      className="shrink-0 rounded-full"
      style={{
        width: '0.25cqw',
        height: '0.25cqw',
        background: `${GOLD} 0.45)`,
      }}
    />
  );
}

/**
 * Renders the player line-up for an instance row. For 1v1 matches
 * (seatsMax === 2 or exactly two participants) shows
 *   [Host] VS [Opponent or "Open seat"]
 * For multi-seat matches shows the participants in a horizontal
 * line separated by dots. Empty seats render as muted placeholders
 * while the lobby is still gathering, so the row visualises the
 * full opponent list rather than a "N/M players" count.
 */
export default function MatchupDisplay({
  participants = [],
  seatsMax,
  sorceryCards,
  creatorId,
}) {
  const sorted = [...participants].sort((a, b) => {
    const aHost = a.role === 'creator' ? 0 : 1;
    const bHost = b.role === 'creator' ? 0 : 1;
    if (aHost !== bHost) return aHost - bHost;
    const aJ = a.joinedAt ? new Date(a.joinedAt).getTime() : 0;
    const bJ = b.joinedAt ? new Date(b.joinedAt).getTime() : 0;
    return aJ - bJ;
  });

  const max = seatsMax || sorted.length || 2;
  const is1v1 = max === 2;

  if (is1v1) {
    const host = sorted[0] || null;
    const opponent = sorted[1] || null;
    return (
      <div className="flex flex-wrap items-center gap-2 min-w-0">
        <PlayerChip
          participant={host}
          sorceryCards={sorceryCards}
          isHost={host?.userId === creatorId || host?.role === 'creator'}
        />
        <VsDivider />
        <PlayerChip
          participant={opponent}
          sorceryCards={sorceryCards}
          isHost={opponent?.userId === creatorId}
        />
      </div>
    );
  }

  const slots = [...sorted];
  while (slots.length < max) slots.push(null);

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 min-w-0">
      {slots.map((p, idx) => (
        <Fragment key={p?.userId || `slot-${idx}`}>
          {idx > 0 ? <DotDivider /> : null}
          <PlayerChip
            participant={p}
            sorceryCards={sorceryCards}
            isHost={p?.userId === creatorId || p?.role === 'creator'}
          />
        </Fragment>
      ))}
    </div>
  );
}
